<template>
  <div class="progress-panel" ref="panel">
    <div class="scroll-wrap" :style="height">
      <el-scrollbar style="height: 100%;">
        <ul class="items">
          <li class="item" v-for="(item, index) in list" :key="item.name + index">
            <i class="icon" :class="'icon-' + 'excel'"></i>
            <div class="progress">
              <p class="filename">{{item.name}}</p>
              <div class="progress-bar">
                <div class="progerss-bar-wrap">
                  <el-progress :percentage="item.progress"></el-progress>
                </div>
                <span class="tips" v-if="item.progress < 100">导出中...</span>
                <span class="tips" v-else>导出完毕</span>
              </div>
              <div class="progress-btn">
                <el-button size="mini" round type="primary" v-if="item.progress < 100">取消导出</el-button>
                <el-button size="mini" round type="success" v-else @click="download(item, index)">下载</el-button>
              </div>
            </div>
          </li>
        </ul>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
	name: 'progress-panel',
	props: {
		list: {
			type: Array,
			default() {
				return [];
			}
		},
		isShowPop: {
			type: Boolean,
			default() {
				return false;
			}
		}
	},
	data() {
		return {};
	},
	computed: {
		height() {
			if (this.list.length > 3) {
				return 'height: 290px';
			} else {
				return 'height: auto';
			}
		}
	},
	methods: {
		...mapMutations({ removeDownload: 'REMOVE_DOWNLOAD' }),
		download(item, index) {
			// 移除项
			this.$emit('update:isShowPop', false);
			this.removeDownload(index);
			location.href = item.file_url;
		}
	}
};
</script>


<style lang="scss" scoped>
.progress-panel {
	max-height: 290px;
	overflow: hidden;
	.item {
		display: flex;
		padding: 5px 0;
		border-bottom: 1px solid #f5f5f5;
		.icon {
			color: #01723e;
		}
		.progress {
			flex: 1;
			width: 0;
			.filename {
				padding-bottom: 8px;
				@include no-wrap;
			}
			.progress-bar {
				display: flex;
				align-items: center;
				.progerss-bar-wrap {
					flex: 1;
				}
				.tips {
					font-size: 12px;
				}
			}
			.progress-btn {
				padding: 5px 0;
				text-align: right;
			}
		}
	}
}
</style>
